import { Injectable } from '@angular/core';
import { MimeTypesEnum } from '../utils/enums';
import { FileCopyInfo } from './cloud-storage/models/file-copy-info';

@Injectable({
  providedIn: 'root'
})
export class FileCopyService {
  private readonly defaultInfo: FileCopyInfo = {
    filename: '',
    fileToCopy: null,
    mimeType: MimeTypesEnum.DriveFolder,
    parentToCopy: null,
    copy: false,
  };

  private fileCopyInfo: FileCopyInfo;

  get copyInfo(): FileCopyInfo {
    return this.fileCopyInfo;
  }

  constructor() {
    this.fileCopyInfo = this.defaultInfo;
  }

  setFileCopyInfo(fileCopyInfo: Partial<FileCopyInfo>): void {
    this.fileCopyInfo = {...this.fileCopyInfo, ...fileCopyInfo };
  }

  clear(): void {
    this.fileCopyInfo = this.defaultInfo;
  }
}
